import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
interface Purchase {
  name: string;
  location: string;
  price: string;
  edition: string;
  image: string;
}
const names = ['Sarah M.', 'Michael T.', 'Jennifer L.', 'David K.', 'Emma R.', 'James W.', 'Lisa P.', 'Robert H.', 'Maria G.', 'John D.', 'Ashley B.', 'Chris V.', 'Amanda S.', 'Daniel F.', 'Jessica N.', 'Brandon C.', 'Rachel K.', 'Kevin P.', 'Michelle W.', 'Andrew L.', 'Nicole B.', 'Ryan M.', 'Stephanie H.', 'Brian T.', 'Laura S.', 'Matthew R.', 'Melissa D.', 'Jason F.', 'Angela N.', 'Tyler G.', 'Samantha J.', 'Eric V.', 'Christina A.', 'Justin Z.', 'Rebecca Q.'];
const locations = ['Los Angeles, CA', 'New York, NY', 'Austin, TX', 'Miami, FL', 'Seattle, WA', 'Denver, CO', 'Portland, OR', 'San Diego, CA', 'Phoenix, AZ', 'Chicago, IL', 'Boston, MA', 'Atlanta, GA', 'San Francisco, CA', 'Las Vegas, NV', 'Nashville, TN', 'Dallas, TX', 'Houston, TX', 'Philadelphia, PA', 'Charlotte, NC', 'Orlando, FL', 'Tampa, FL', 'Minneapolis, MN', 'Detroit, MI', 'Salt Lake City, UT', 'Kansas City, MO'];
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  const [usedNames, setUsedNames] = useState<string[]>([]);
  const {
    language
  } = useLanguage();
  const generatePurchase = (): Purchase => {
    const isPhysical = Math.random() > 0.3;
    // Get available names (not recently used)
    const availableNames = names.filter(name => !usedNames.includes(name));
    const namePool = availableNames.length > 0 ? availableNames : names;
    const randomName = namePool[Math.floor(Math.random() * namePool.length)];
    const randomLocation = locations[Math.floor(Math.random() * locations.length)];
    // Update used names, keep only last 10
    setUsedNames(prev => {
      const updated = [...prev, randomName];
      return updated.slice(-10);
    });
    // Update edition text and price based on language
    const editionText = language === 'es' ? isPhysical ? 'Pack Despertar' : 'Edición Digital' : isPhysical ? 'Physical Book' : 'Digital Edition';
    const price = language === 'es' ? isPhysical ? '$49.97' : '$24.97' : isPhysical ? '$49.97' : '$24.97';
    return {
      name: randomName,
      location: randomLocation,
      price: price,
      edition: editionText,
      image: isPhysical ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/3QXbKH8MkBDm42326D8Lnu/Generated_Image_October_27%2C_2025_-_5_58PM.png' : 'https://uploadthingy.s3.us-west-1.amazonaws.com/oyz5GB8MJJnmomK7GwM4JC/Generated_Image_October_27%2C_2025_-_5_59PM.png'
    };
  };
  useEffect(() => {
    const showNotification = () => {
      setPurchase(generatePurchase());
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(showNotification, 3000);
    // Show subsequent notifications every 8-15 seconds
    const scheduleNext = () => {
      const randomDelay = 8000 + Math.random() * 7000;
      setTimeout(() => {
        showNotification();
        scheduleNext();
      }, randomDelay);
    };
    setTimeout(scheduleNext, 3000);
    return () => {
      clearTimeout(initialTimeout);
    };
  }, [language]);
  if (!purchase) return null;
  return <div className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`} style={{
    maxWidth: '500px',
    width: 'calc(100% - 2rem)'
  }} data-id="element-191">
      <div className="bg-gray-900/90 backdrop-blur-xl rounded-lg border border-teal-500/30 overflow-hidden shadow-2xl" data-id="element-192">
        <div className="flex items-center gap-4 p-4" data-id="element-193">
          <div className="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-teal-950/50 border border-teal-500/20" data-id="element-194">
            <img src={purchase.image} alt="Book" className="w-full h-full object-cover" data-id="element-195" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-196">
            <div className="flex items-center gap-2 mb-1" data-id="element-197">
              <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" data-id="element-198"></div>
              <p className="text-sm font-semibold text-teal-200" data-id="element-199">
                Recent Purchase
              </p>
            </div>
            <p className="text-sm text-gray-300 mb-1" data-id="element-200">
              <span className="font-medium text-white" data-id="element-201">{purchase.name}</span>{' '}
              from {purchase.location}
            </p>
            <p className="text-xs text-teal-300" data-id="element-202">
              {purchase.edition} •{' '}
              <span className="font-semibold text-yellow-400" data-id="element-203">
                {purchase.price}
              </span>
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="flex-shrink-0 text-gray-500 hover:text-teal-300 transition-colors" data-id="element-204">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-205">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-206" />
            </svg>
          </button>
        </div>
        <div className="h-1 bg-gradient-to-r from-teal-500 via-green-400 to-teal-500" data-id="element-207"></div>
      </div>
    </div>;
}